/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";
import {
  getArbitratorDecisionDecoder,
  getArbitratorDecisionEncoder,
  type ArbitratorDecision,
  type ArbitratorDecisionArgs,
} from ".";

export type DisputeResolvedEvent = {
  escrowId: bigint;
  decision: ArbitratorDecision;
  arbitrator: Address;
};

export type DisputeResolvedEventArgs = {
  escrowId: number | bigint;
  decision: ArbitratorDecisionArgs;
  arbitrator: Address;
};

export function getDisputeResolvedEventEncoder(): Encoder<DisputeResolvedEventArgs> {
  return getStructEncoder([
    ["escrowId", getU64Encoder()],
    ["decision", getArbitratorDecisionEncoder()],
    ["arbitrator", getAddressEncoder()],
  ]);
}

export function getDisputeResolvedEventDecoder(): Decoder<DisputeResolvedEvent> {
  return getStructDecoder([
    ["escrowId", getU64Decoder()],
    ["decision", getArbitratorDecisionDecoder()],
    ["arbitrator", getAddressDecoder()],
  ]);
}

export function getDisputeResolvedEventCodec(): Codec<
  DisputeResolvedEventArgs,
  DisputeResolvedEvent
> {
  return combineCodec(
    getDisputeResolvedEventEncoder(),
    getDisputeResolvedEventDecoder(),
  );
}
